export class Marca {
  idMarca: number;
  descricao: string;
  imagem: string;

  imagem$: any;
  buscouImagem: boolean;
}
